import React from "react";
import { Box, Typography } from "@material-ui/core";
import numberFormatter from "utils/numberFormatter";

import { useAppSelector } from "store";
import { selectMonthPeriodLabel, selectNumberOfPeriods, selectStore } from "modules/customer/insights/portfolioNew/portfolioSlice";
import { selectSelectedStoreYearlyRevenue } from "modules/customer/insights/portfolioNew/revenue/revenueSlice";
import KPIComparison from "components/visuals/KPIComparison";
import PercentageIndicator from "components/visuals/PercentageIndicator";
import mathUtils from "utils/mathUtils";

const StoreForecastRevenueVsPY = () => {
    const selectedStore = useAppSelector(selectStore);
    const storeForecastRevenueVsPY = useAppSelector(selectSelectedStoreYearlyRevenue);
    const { isLoading, hasErrors, data } = storeForecastRevenueVsPY;
    const valueFormatted = numberFormatter.toGBP(data.nextYear);
    const comparisonValue = numberFormatter.toGBP(data.currentYear);
    const differenceValue = mathUtils.safePercentageChange(data.nextYear, data.currentYear);
    const monthPeriodLabel = useAppSelector(selectMonthPeriodLabel);
    const numberOfPeriods = useAppSelector(selectNumberOfPeriods);
    const label = `${selectedStore?.name} next ${numberOfPeriods} ${monthPeriodLabel}s ${data.label} forecast revenue`;

    return (
        <Box width="100%" height="100%" data-cy="store-forecast-revenue-vs-py">
            <KPIComparison
                isLoading={isLoading}
                hasErrors={hasErrors}
                targetValue={
                    <Typography variant="h3" component="div" style={{ color: "#FFFFFF" }}>
                        {valueFormatted}
                    </Typography>
                }
                targetLabel={label}
                comparisonValue={
                    <PercentageIndicator loading={false} error={false} value={differenceValue} switchColor={false} noDataMessage={""} />
                }
                comparisonLabel={`% change from last ${numberOfPeriods} ${monthPeriodLabel}s`}
                differenceValue={
                    <Typography variant="h6" component="div">
                        {comparisonValue}
                    </Typography>
                }
                differenceLabel={`Last ${numberOfPeriods} ${monthPeriodLabel}s revenue`}
            />
        </Box>
    );
};

export default StoreForecastRevenueVsPY;
